
import React from 'react';
import {Img1,Img2,Img3} from "../../svg/index";
import AvatarCircle from "./AvatarCircle";

const IconProgressBar = ({indexProgress}) => {
    const widthIcon = 77;
    
    const arrIcons =
    [
        <Img1 width={widthIcon} className="" indexProgress={indexProgress}  />,
        <Img2 width={widthIcon} className="" indexProgress={indexProgress}/>,
        <Img3 width={widthIcon} className="" indexProgress={indexProgress}/>
    ]


    return (
        <div className="sg-iconbar-soa">
            {arrIcons.map((icon, index) => 
                <AvatarCircle key={index} index={index} indexProgress={indexProgress} width={widthIcon}>
                    {icon}
                </AvatarCircle>
               
            )}
            
        </div>
    );
}


export default IconProgressBar;
